var Backbone = require('backbone');
var _ = require('underscore');
var $ = require('jquery');
// var toastr = require('toastr');
// const toastr = require('../helpers/toastr-config');
const notifications = require('../helpers/custom-notifications');
var SubtitleScope = require('../scopes/subtitle');
var STATUSES = SubtitleScope.VARIABLES.STATUSES;
var reader = require('../helpers/reader');
var dispatcher = require('../dispatcher');
var template = require('../templates/subtitle-editor.jade');
const languageContainer = require('../helpers/language-container');

module.exports = Backbone.View.extend({
	events: {
		'click .up': 'arrowUp',
		'click .down': 'arrowDown',
		'click .check': 'updateSub',
		'click .close': 'closeEditor',
		'click .play': 'playSection',
		'click .italic': 'italicFont',
		'click .background': 'blackBg',
		'click .now': 'nowTimestamp',

		'click input[type="text"]': 'jumpToTime',
		'keydown input[type="text"]': 'timeControl',

		'keydown textarea': 'subtitleLimitControl',
		'keyup textarea': 'subtitleLengthControl',

		contextmenu: 'onRightClick'
	},

	model: null,
	subtitleModel: null,
	autoRender: true,
	hasBox: false,
	changed: false,
	originalSubtitleModel: null,
	updateDisplayTimeout: null,

	initialize: function (options) {
		_.extend(this, options);
	
		_.bindAll(this, 'updateSub', 'updateSubScreen', 'arrowUp', 'arrowDown',
			'nowTimestamp', 'checkConflict', 'timeControl', 'getNewStatus', 'emitTimecodesPreview');
	
		this.listenTo(dispatcher, dispatcher.events.UPDATE_COUNT, this.updateCount);
		this.listenTo(dispatcher, dispatcher.events.UPDATE_DURATION, this.updateDuration);
	
		this.subtitleModel = this.model.getCurrentModel();
		// Store original subtitle model for display restoration on cancel
		this.originalSubtitleModel = this.subtitleModel ? new Backbone.Model(this.subtitleModel.toJSON()) : null;
	
		this.listenTo(this.model, 'change', _.bind(function () {
			this.subtitleModel = this.model.getCurrentModel();
			this.bindData();
		}, this));
	
		$('.subtitle-display input[type="text"]').prop('readonly', true);
	
		_.debounce(_.bind(function () {
			this.$('textarea').focus();
		}, this))();
	
		dispatcher.emit(dispatcher.events.DISABLE_KEYBOARD_CONTROLS, true);
		if (this.autoRender)
			this.render();
	
		// // Set toastr options here
		// toastr.options = {
		// 	"closeButton": false,
		// 	"debug": false,
		// 	"newestOnTop": false,
		// 	"progressBar": false,
		// 	"positionClass": "toast-top-center", // Change this to your desired position
		// 	"preventDuplicates": false,
		// 	"onclick": null,
		// 	"showDuration": "300",
		// 	"hideDuration": "1000",
		// 	"timeOut": "5000",
		// 	"extendedTimeOut": "1000",
		// 	"showEasing": "swing",
		// 	"hideEasing": "linear",
		// 	"showMethod": "fadeIn",
		// 	"hideMethod": "fadeOut"
		// };
	
		// console.log('Toastr options set:', toastr.options);
	},
	
	

	render: function () {
		this.setElement(template());

		this.bindData();

		dispatcher.emit(dispatcher.events.SYNC, false);

		return this;
	},

	bindData: function () {
		this.$('.old-time1').html(reader.convertToTime(this.model.get('editStack').at(0).get('frameStart')));
		this.$('.old-time2').html(reader.convertToTime(this.model.get('editStack').at(0).get('frameEnd')));

		this.$('.time1 input').val(reader.convertToTime(this.subtitleModel.get('frameStart')));
		this.$('.time2 input').val(reader.convertToTime(this.subtitleModel.get('frameEnd')));

		var row1 = this.subtitleModel.get('row1') ? String(this.subtitleModel.get('row1')) : '';
		var row2 = this.subtitleModel.get('row2') ? String(this.subtitleModel.get('row2')) : '';

		if (this.subtitleModel.get('italic')) this.$('textarea').addClass('italic-font');

		
		const currentTextValue =  this.$('textarea').val();
		const isUpdatedFromCaptionsWave = currentTextValue && currentTextValue.length > 0;
		if (!isUpdatedFromCaptionsWave) {
			const text = ((row1.length ? row1 : '\n') + (row2.length ? '\n' + row2 : '')).trim();
			this.$('textarea').val(text);
		}

		// Auto-detect text direction for existing content
		this.autoDetectTextDirection(this.$('textarea')[0]);

		this.$('.duration-value').html(reader.convertMinToTime(this.subtitleModel.get('frameEnd') - this.subtitleModel.get('frameStart')));

		var maxCharactersInLine = reader.maxCharactersInLine;

		//this.model.get('maxCharactersInLine');
		// if (maxCharactersInLine === undefined) {
		// 	maxCharactersInLine = localStorage.getItem("maxCharactersInLine");
		// }
		var row1Length = row1 ? row1.length : 0;
		var row2Length = row2 ? row2.length : 0;

		this.$('.text-valueL1').html('(' + row1Length + '/' + maxCharactersInLine + ')');
		this.$('.text-valueL2').html('(' + row2Length + '/' + maxCharactersInLine + ')');

		if ((row1Length > maxCharactersInLine)) {
			this.$('.text-valueL1').css("color", "red");
		} else {
			this.$('.text-valueL1').css("color", "");
		}

		if (row2Length > maxCharactersInLine) {
			this.$('.text-valueL2').css("color", "red");
		} else {
			this.$('.text-valueL2').css("color", "");
		}
	},

	emitTimecodesPreview: function () {
		var timeStart = this.$('.time1.wrap input').val();
		var timeEnd = this.$('.time2.wrap input').val();
		var frameStart = reader.convertToFrames(timeStart, true);
		var frameEnd = reader.convertToFrames(timeEnd, true);
		if (frameStart !== false && frameEnd !== false) {
			dispatcher.emit(dispatcher.events.CAPTION_TIMECODES_PREVIEW, {
				id: this.model.id,
				frameStart: frameStart,
				frameEnd: frameEnd
			});
		}
	},

	arrowUp: function (e) {
		var $this = $(e.currentTarget);
		var $input = $this.parent().siblings('input');
		var time = $input.val();

		if (!time) return;

		var frame = reader.convertToFrames(time, true);
		var $parent = $this.parents('.wrap');
		var $sibling = $parent.siblings('.wrap').find('input');

		var nextSubFrameVal;
		var nextModel = this.model.getNextSubtitle();
		if (nextModel)
			nextSubFrameVal = nextModel.getCurrentModel().get('frameStart');
		else
			//this is the last subtitle in the editor
			nextSubFrameVal = -1;

		var isTime1 = $parent.index() == 0;

		var maxFrame = isTime1 ? reader.convertToFrames($sibling.val(), true) : nextSubFrameVal;

		var nextFrame = parseInt(frame) + 1;

		if (nextFrame + 1 >= maxFrame && nextSubFrameVal != -1) {
			notifications.error('This is the maximum subtitle time you can set.');
			return;
		} else if (nextSubFrameVal === -1 && maxFrame != -1) {
			if (nextFrame >= maxFrame) {
				notifications.error('This is the maximum subtitle time you can set.');
				return;
			}
		}

		dispatcher.emit(dispatcher.events.JUMP_TO_FRAME, nextFrame);

		$input.val(reader.convertToTime(nextFrame));

		dispatcher.emit(dispatcher.events.UPDATE_DURATION, this.model);
		this.emitTimecodesPreview();
	},

	arrowDown: function (e) {
		var $this = $(e.currentTarget);
		var $input = $this.parent().siblings('input');
		var time = $input.val();

		if (!time) return;

		var frame = reader.convertToFrames(time, true);
		var $parent = $this.parents('.wrap');
		var $sibling = $parent.siblings('.wrap').find('input');

		var prevModel = this.model.getPreviousSubtitle();
		var prevSubFrameVal = prevModel ? prevModel.getCurrentModel().get('frameEnd') : 0;

		var isTime1 = $parent.index() == 0;

		var minFrame = isTime1 ? prevSubFrameVal : reader.convertToFrames($sibling.val(), true);

		var prevFrame = parseInt(frame) - 1;

		if (prevFrame -1 <= parseInt(minFrame)) {
			notifications.error('This is the minimum subtitle time you can set.');
			return;
		}

		dispatcher.emit(dispatcher.events.JUMP_TO_FRAME, prevFrame);

		$input.val(reader.convertToTime(prevFrame));

		dispatcher.emit(dispatcher.events.UPDATE_DURATION, this.model);
		this.emitTimecodesPreview();
	},
	
	getChangesFromView: async function() {
		if (this.checkConflict()) {
			return;
		}

		var timeStart = this.$('.time1.wrap input').val();
		var timeEnd = this.$('.time2.wrap input').val();

		var frameStart = reader.convertToFrames(timeStart, true);
		var frameEnd = reader.convertToFrames(timeEnd, true);

		if (frameStart === false || frameEnd === false) {
			notifications.error('Incorrect ' + (frameStart === false ? 'start' : 'end') + ' time. Please update before saving.');
			return;
		}

		var txt = this.$('textarea').val();
		var rows = _.compact(txt.split('\n'));
		var hasItalic = this.$('textarea').hasClass('italic-font');
		var row1 = rows[0] ? rows[0].trim() : '';
		var row2 = rows[1] ? rows[1].trim() : '';

		await this.validateRowsAndWaitForResponse(row1, row2);

		return {
			frameEnd: frameEnd,
			frameStart: frameStart,
			italic: hasItalic,
			row1: row1,
			row2: row2,
			timeEnd: timeEnd,
			timeStart: timeStart,
			hasBox: this.hasBox,
		};

	},
	updateSub: async function () {
		var changes = await this.getChangesFromView();
		if (changes == null) {
			return;
		}

		var isNewSubtitle = this.model.id == null && this.model.statusNew();
		var isModelChanged = this.model.isDataMatch(changes) == false;
	
		if (isModelChanged || this.changed) {
		var isChangesMatchOriginalValues = this.model.isDataMatchOriginal(changes);
		if (isChangesMatchOriginalValues && !this.model.statusNew()) {
			this.model.undoToOriginal();
			this.remove();
			return;
		}

			var newStatus = this.getNewStatus(changes);
			var actionToRequest;
			var actionToTakeAfterEventCompleted;

			dispatcher.emit(dispatcher.events.UPDATE_SUB);

			if (isNewSubtitle && isModelChanged) {
				actionToRequest = dispatcher.events.DB_INSERT_SUBTITLE;
				actionToTakeAfterEventCompleted = () => this.model.setData(changes, newStatus, true);
			} else {
				actionToRequest = dispatcher.events.DB_UPDATE_SUBTITLE;
				actionToTakeAfterEventCompleted = () => this.model.addToStack(changes, newStatus);
			}

			try {
				this.$('.check').prop('disabled', true);
				
				await dispatcher.emit(actionToRequest, {
					item: this.model,
					changes: changes,
					status: newStatus
				});
			}
			catch(e) {
				return;
			}
			finally {
				this.$('.check').prop('disabled', false);
			}

			actionToTakeAfterEventCompleted();
		}

		this.remove();
	},

	validateRowsAndWaitForResponse: function (row1, row2) {
		// Hard limit: no subtitle line can exceed 100 characters
		const ABSOLUTE_MAX_CHARACTERS = 100;

		var firstRowLength = row1 == null ? 0 : row1.trim().length;
		var secondRowLength = row2 == null ? 0 : row2.trim().length;

		var isEmptyCaption = firstRowLength + secondRowLength == 0;
		if (isEmptyCaption) {
			var isNewSubtitle = this.model.id == null && this.model.statusNew();
			var errorMessage = isNewSubtitle ?
				"Enter text in order to save the new title" :
				"To delete the subtitle use the \'Delete Subtitle\' button";

			notifications.error(errorMessage);
			return Promise.reject();
		}

		// Hard restriction: prevent saving if any line exceeds 100 characters
		// The red text color provides visual feedback, no alert needed
		var isAbsoluteMaxExceeded = firstRowLength > ABSOLUTE_MAX_CHARACTERS || secondRowLength > ABSOLUTE_MAX_CHARACTERS;
		if (isAbsoluteMaxExceeded) {
			notifications.error('You have exceeded the maximum number of characters per line\n\nThe subtitles cannot be saved.');
			return Promise.reject();
		}

		// No alerts for database limit - red text color is sufficient feedback
		// User can still save as long as it's under 100 characters
	},

	playSection: function () {
		dispatcher.emit(dispatcher.events.PLAY_SECTION, this.model);
	},

	italicFont: function () {
		this.$('textarea').toggleClass('italic-font');
		this.changed = true;
	},

	blackBg: function () {
		var hasBox = !this.model.get('hasBox');

		this.model.set('hasBox', hasBox);
		this.hasBox = hasBox;
		this.changed = true;

		dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY, this.model, true);
	},

	nowTimestamp: function (e) {
		var $this = $(e.currentTarget);
		var $input = $this.siblings('input');
		var $parent = $this.parents('.wrap');
		var $siblingInput = $parent.siblings('.wrap').find('input');
		var $video = $('video')[0];

		var value = $video.currentTime * reader.frameRate;

		if (reader.convertToFrames($siblingInput.val(), true) == value) {
			value = $parent.hasClass('time1') ? value - 1 : parseInt(value) + 1;
		}

		$input.val(reader.toHMS(value / reader.frameRate));
		$input.focus();

		dispatcher.emit(dispatcher.events.UPDATE_DURATION, this.model);
		this.emitTimecodesPreview();
	},

	jumpToTime: function (e) {
		var $this = $(e.currentTarget);
		var time = reader.convertToFrames($this.val(), true);

		if (time !== false) {
			dispatcher.emit(dispatcher.events.JUMP_TO_FRAME, time);
		}
	},

	checkConflict: function () {
		var timeStart = this.$('.time1.wrap input');
		var timeEnd = this.$('.time2.wrap input');

		var frameStart = reader.convertToFrames(timeStart.val(), true);
		var frameEnd = reader.convertToFrames(timeEnd.val(), true);

		var prevModel = this.model.getPreviousSubtitle();
		var nextModel = this.model.getNextSubtitle();

		if (frameStart === frameEnd) {
			notifications.warning('Start time can\'t be equal to end time.');
			timeStart.val(reader.convertToTime(this.subtitleModel.get('frameStart')));
			timeEnd.val(reader.convertToTime(this.subtitleModel.get('frameEnd')));
			return true;
		}
		if (frameStart > frameEnd) {
			notifications.warning('Start time is greater than the end time.');
			timeStart.val(reader.convertToTime(this.subtitleModel.get('frameStart')));
			timeEnd.val(reader.convertToTime(this.subtitleModel.get('frameEnd')));
			return true;
		}

		if (prevModel && parseInt(prevModel.getCurrentModel().get('frameEnd')) > frameStart) {
			notifications.warning('Subtitle time overlaps with previous subtitle.');
			timeStart.val(reader.convertToTime(this.subtitleModel.get('frameStart')));
			return true;
		}

		if (nextModel && parseInt(nextModel.getCurrentModel().get('frameStart')) < frameEnd) {
			notifications.warning('Subtitle time overlaps with next subtitle.');
			timeEnd.val(reader.convertToTime(this.subtitleModel.get('frameEnd')));
			return true;
		}

		if (nextModel && parseInt(nextModel.getCurrentModel().get('frameStart')) == frameEnd) {
			notifications.warning('Subtitle time overlaps with next subtitle.');
			timeEnd.val(reader.convertToTime(this.subtitleModel.get('frameEnd')));
			return true;
		}

		if (prevModel && parseInt(prevModel.getCurrentModel().get('frameEnd')) == frameStart) {
			notifications.warning('Subtitle time overlaps with previous subtitle.');
			timeStart.val(reader.convertToTime(this.subtitleModel.get('frameStart')));
			return true;
		}

		return false;
	},

	onRightClick: function (e) {
		var $this = $(e.target);
		if (!$this.attr('id') == 'editor') e.preventDefault();
	},

	timeControl: function (e) {
		var keyCode = e.keyCode;

		if (keyCode < 37 || keyCode > 40)
			e.preventDefault();

		if (keyCode == 38 || keyCode == 40)
			this.arrowTimeControl(e);
		else
		if ((keyCode >= 48 && keyCode <= 57))
			this.keyboardTimeControl(e);

		if (keyCode >= 96 && keyCode <= 105) {
			e.keyCode = e.keyCode - 48;
			this.keyboardTimeControl(e);
		}
	},

	arrowTimeControl: function (e) {

		e.preventDefault();

		var $el = $(e.currentTarget);
		var elValue = $el.val();
		var currentFrame = reader.convertToFrames(elValue, true);
		var frameRate = this.model.get('frameRate');

		var isTime1 = !!$el.closest('.time1').length;

		var caret = e.currentTarget.selectionStart;
		var dataSetPosition = Math.floor(caret / 3);

		var model, value, limitFrame, increment;

		var isHour = dataSetPosition === 0;
		var isMinute = dataSetPosition === 1;
		var isSecond = dataSetPosition === 2;
		var isFrame = dataSetPosition === 3;

		if (isFrame) increment = 1;
		else if (isSecond) increment = frameRate;
		else if (isMinute) increment = frameRate * 60;
		else if (isHour) increment = frameRate * 60 * 60;

		if (e.shiftKey) increment *= 10;

		if (e.keyCode == 38) { //up
			if (isTime1) {
				limitFrame = this.model.getCurrentModel().get('frameEnd');
			} else {
				model = this.model.getNextSubtitle();
				limitFrame = model ? model.getCurrentModel().get('frameStart') : 1;
			}

			value = currentFrame + increment;
			if (value >= limitFrame) value = limitFrame - 1;

		} else { // down
			if (isTime1) {
				model = this.model.getPreviousSubtitle();
				limitFrame = model ? model.getCurrentModel().get('frameEnd') : -1;
			} else {
				limitFrame = this.model.getCurrentModel().get('frameStart');
			}

			value = currentFrame - increment;
			if (value < 0) value = 0;
			if (value <= limitFrame) value = limitFrame + 1;
		}

		$el.val(reader.convertToTime(value));

		e.currentTarget.selectionStart = dataSetPosition * 3;
		e.currentTarget.selectionEnd = dataSetPosition * 3 + 2;

		this.emitTimecodesPreview();
	},

	keyboardTimeControl: function (e) {
		//TODO: move this on the global init
		String.prototype.replaceAt = function (index, character) {
			return this.substr(0, index) + character + this.substr(index + character.length);
		};

		var $el = $(e.currentTarget);
		var elValue = $el.val();
		var frameRate = reader.frameRate;

		var isTime1 = !!$el.closest('.time1').length;

		var keyPressed = String.fromCharCode(e.keyCode);

		var caret = e.currentTarget.selectionStart;
		if (caret % 3 == 2) caret += 1;

		var dataSetPosition = Math.floor(caret / 3);
		if (dataSetPosition > 3)
			return;

		var isMinute = dataSetPosition === 1;
		var isSecond = dataSetPosition === 2;
		var isFrame = dataSetPosition === 3;

		var value = elValue.replaceAt(caret, keyPressed);

		var timeString = value.split('.')[0];
		var frames = value.split('.')[1];

		var times = timeString.split(':');

		if (times[2] >= 60 && isSecond) {
			times[2] = '59';
		} else if (times[1] >= 60 && isMinute) {
			times[1] = '59';
		}

		if (frames >= frameRate && isFrame) {
			frames = '24';
		}

		value = times.join(':') + '.' + frames;
		var currentFrame = reader.convertToFrames(value, true);

		var limitFrameModel, limitFrameSubtitle, model;
		if (isTime1) {
			limitFrameModel = this.model.getCurrentModel().get('frameEnd');

			model = this.model.getPreviousSubtitle();
			limitFrameSubtitle = model ? model.getCurrentModel().get('frameEnd') : 1;
			value = reader.convertToTime(currentFrame);
		} else {
			model = this.model.getNextSubtitle();
			limitFrameSubtitle = model ? model.getCurrentModel().get('frameStart') : -1;

			limitFrameModel = this.model.getCurrentModel().get('frameStart');
			value = reader.convertToTime(currentFrame);
		}

		$el.val(value);

		e.currentTarget.selectionStart = caret + 1;
		e.currentTarget.selectionEnd = caret + 1;

		this.emitTimecodesPreview();
	},

	subtitleLimitControl: function (e) {
		var $this = $(e.currentTarget);
		var rows = $this.val().split("\n");
		var newLines = rows.length;

		var keyCode = e.keyCode;

		var maxCharactersInLine = reader.maxCharactersInLine;

		var isNewLine = (keyCode == 13 || keyCode == 176);

		if (newLines >= 2 && isNewLine) {
			var isLastLineIsEmpty = rows[1] == "";
			if (!isLastLineIsEmpty) {
				return e.preventDefault();
			}
			$this.val(rows.slice(0, 1).join('\n'));
		}
	},

	subtitleLengthControl: function (e) {

		var maxCharactersInLine = reader.maxCharactersInLine;

		_.debounce(function () {
			var selectionStart = e.currentTarget.selectionStart;
			var selectionEnd = e.currentTarget.selectionEnd;
			var $this = $(e.currentTarget);
			var rows = $this.val().split("\n");

			dispatcher.emit(dispatcher.events.UPDATE_COUNT, rows);

		}, 100)();

		// Auto-detect and set text direction based on content
		this.autoDetectTextDirection(e.currentTarget);

		// Update subtitle display in player after 500ms delay
		this.updateSubtitleDisplayInPlayer();
	},

	/**
	 * Get text direction category based on language value.
	 * Returns: 'mixed', 'rtl', or 'ltr'
	 */
	getTextDirectionCategory: function(languageValue) {
		if (!languageValue) {
			return 'ltr'; // Default to LTR if language not available
		}
		
		var lang = languageValue.toLowerCase();
		
		// Mixed Languages (RTL + LTR): Use natural bidi
		// Matches DB values: Hebrew-English, Arabic-English, Hebrew-French, 
		// Hebrew-English-Supers, Arabic-English-Supers, Hebrew-French-Supers
		var mixedLanguages = [
			'hebrew-english',
			'arabic-english',
			'hebrew-french',
			'hebrew-english-supers',
			'arabic-english-supers',
			'hebrew-french-supers'
		];
		
		if (mixedLanguages.indexOf(lang) !== -1) {
			return 'mixed';
		}
		
		// RTL Languages: Use RTL with right alignment
		// Matches DB values (case-insensitive): Hebrew, Arabic, Persian, Yiddish, Tigrinya, Amharic,
		// Heb-Arb, Heb-Arb-Supers, Hebrew-VTT, Other-HE, Other-AR, Supers-HE, Supers-ARB, Supers-AMH, Supers-YI
		// Note: Array values are lowercase for case-insensitive comparison
		var rtlLanguages = [
			'hebrew',           // DB: Hebrew
			'arabic',           // DB: Arabic
			'persian',          // DB: Persian
			'yiddish',          // DB: Yiddish
			'tigrinya',         // DB: Tigrinya
			'amharic',          // DB: Amharic
			'heb-arb',          // DB: Heb-Arb
			'heb-arb-supers',   // DB: Heb-Arb-Supers
			'hebrew-vtt',       // DB: Hebrew-VTT
			'other-he',         // DB: Other-HE (behaves like Hebrew)
			'other-ar',         // DB: Other-AR (behaves like Hebrew)
			'supers-he',        // DB: Supers-HE
			'supers-arb',       // DB: Supers-ARB
			'supers-amh',       // DB: Supers-AMH
			'supers-yi'         // DB: Supers-YI
		];
		
		if (rtlLanguages.indexOf(lang) !== -1) {
			return 'rtl';
		}
		
		// All other languages are LTR: Use LTR with left alignment
		return 'ltr';
	},

	autoDetectTextDirection: function(textarea) {
		var $textarea = $(textarea);
		var currentLanguage = languageContainer.get();
		var languageValue = currentLanguage ? currentLanguage.value : null;
		var category = this.getTextDirectionCategory(languageValue);

		switch (category) {
			case 'mixed':
				$textarea.css({
					'direction': 'initial',
					'unicode-bidi': 'plaintext',
					'text-align': 'start'
				});
				break;

			case 'rtl': {
				// For RTL languages, use LTR when the text is non-empty and
				// contains no RTL characters (e.g. a pure English subtitle)
				var text = $textarea.val();
				var rtlRegex = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
				var isPurelyLtr = text && text.trim().length > 0 && !rtlRegex.test(text);
				$textarea.css({
					'direction': isPurelyLtr ? 'ltr' : 'rtl',
					'text-align': isPurelyLtr ? 'left' : 'right',
					'unicode-bidi': 'normal'
				});
				break;
			}

			case 'ltr':
			default:
				$textarea.css({
					'direction': 'ltr',
					'text-align': 'left',
					'unicode-bidi': 'normal'
				});
				break;
		}
	},

	closeEditor: function () {
		// Restore original subtitle display in player
		this.restoreOriginalSubtitleDisplay();
		
		this.forceRemove();
		var model = this.model.getCurrentModel();

		if (!model.get('row1').length && !model.get('row2').length && !!this.model.collection && !this.model.isNew()) {
			var index = this.model.collection.indexOf(this.model);

			$('.subtitles .row.subtitle').eq(index).remove();
			this.model.collection.remove(this.model);
		}
	},

	remove: function () {

		if (this.checkConflict()) return;

		// Clear any pending display updates
		clearTimeout(this.updateDisplayTimeout);

		// Clear timecodes preview on Caption Wave
		dispatcher.emit(dispatcher.events.CAPTION_TIMECODES_PREVIEW, null);

		// COMPLETELY UNBIND THE VIEW
		this.undelegateEvents();

		this.$el.removeData().unbind();
		this.$el.siblings('.editing').removeClass('editing');

		Backbone.View.prototype.remove.apply(this, arguments);

		$('.subtitle-display input[type="text"]').prop('readonly', false);

		dispatcher.emit(dispatcher.events.SYNC, true);
		dispatcher.emit(dispatcher.events.ENABLE_KEYBOARD_CONTROLS);
	},

	//this is a temp solution for the close button after insert wrong time codes
	//

	restoreOriginalSubtitleDisplay: function () {
		clearTimeout(this.updateDisplayTimeout);
		if (this.originalSubtitleModel && this.model) {
			// Create model-like object with original data
			var originalModel = {
				getCurrentModel: function() { return this.originalSubtitleModel; }.bind(this),
				get: function(key) { 
					if (key === 'hasBox') return this.model.get('hasBox');
					if (key === 'status') return this.model.get('status');
					return this.model.get(key);
				}.bind(this)
			};
			dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY, originalModel, true);
		}
	},

	forceRemove: function () {
		// Clear timecodes preview on Caption Wave
		dispatcher.emit(dispatcher.events.CAPTION_TIMECODES_PREVIEW, null);

		// COMPLETELY UNBIND THE VIEW
		this.undelegateEvents();

		this.$el.removeData().unbind();
		this.$el.siblings('.editing').removeClass('editing');

		Backbone.View.prototype.remove.apply(this, arguments);

		$('.subtitle-display input[type="text"]').prop('readonly', false);

		dispatcher.emit(dispatcher.events.SYNC, true);
		dispatcher.emit(dispatcher.events.ENABLE_KEYBOARD_CONTROLS);

	},

	updateCount: function (rows) {
		// var maxCharactersInLine = this.model.get('maxCharactersInLine');
		// if (maxCharactersInLine === undefined) {
		// 	maxCharactersInLine = localStorage.getItem("maxCharactersInLine");
		// }
		var maxCharactersInLine = reader.maxCharactersInLine;
		var row1 = rows[0] ? rows[0].length : 0;
		var row2 = rows[1] ? rows[1].length : 0;

		this.$('.text-valueL1').html('(' + row1 + '/' + maxCharactersInLine + ')');
		this.$('.text-valueL2').html('(' + row2 + '/' + maxCharactersInLine + ')');


		if ((rows[0] && rows[0].length > maxCharactersInLine)) {
			this.$('.text-valueL1').css("color", "red");
		} else {
			this.$('.text-valueL1').css("color", "");
		}

		if (rows[1] && rows[1].length > maxCharactersInLine) {
			this.$('.text-valueL2').css("color", "red");
		} else {
			this.$('.text-valueL2').css("color", "");
		}
	},
	updateDuration: function (rows) {
		var timeStart = this.$('.time1.wrap input').val();
		var timeEnd = this.$('.time2.wrap input').val();

		var frameStart = reader.convertToFrames(timeStart, true);
		var frameEnd = reader.convertToFrames(timeEnd, true);

		this.$('.duration-value').html(reader.convertMinToTime(frameEnd - frameStart));
	},

	updateSubtitleDisplayInPlayer: function () {
		clearTimeout(this.updateDisplayTimeout);
		var self = this;
		this.updateDisplayTimeout = setTimeout(function() {
			if (!self.subtitleModel) return;
			
			var txt = self.$('textarea').val();
			var rows = _.compact(txt.split('\n'));
			var hasItalic = self.$('textarea').hasClass('italic-font');
			
			var row1 = rows[0] ? rows[0].trim() : '';
			var row2 = rows[1] ? rows[1].trim() : '';
			
			// Create temporary model with edited text for display only
			var tempModelData = self.subtitleModel.toJSON();
			tempModelData.row1 = row1;
			tempModelData.row2 = row2;
			tempModelData.italic = hasItalic;
			
			var tempModel = new Backbone.Model(tempModelData);
			// Wrap in a model-like object that subtitle-display expects
			var displayModel = {
				getCurrentModel: function() { return tempModel; },
				get: function(key) { 
					if (key === 'hasBox') return self.model.get('hasBox');
					if (key === 'status') return self.model.get('status');
					return self.model.get(key);
				}
			};
			
			dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY, displayModel, true);
		}, 500);
	},

	updateSubScreenTimer: function () {
		clearInterval(this.updateSubTimeout);
		this.updateSubTimeout = setTimeout(this.updateSubScreen, 700);
	},

	updateSubScreen: function () {
		var newData = this.model.getCurrentModel().toJSON();

		var row1 = this.$('.subtitle-display .row1-subtitle').html();
		var row2 = this.$('.subtitle-display .row2-subtitle').html();

		if (newData['row1'] == row1 && newData['row2'] == row2)
			return;

		var txt = this.$('textarea').val();
		var rows = _.compact(txt.split('\n'));

		var hasItalic = this.$('textarea').hasClass('italic-font');

		var row1 = rows[0] ? rows[0].trim() : '';
		var row2 = rows[1] ? rows[1].trim() : '';

		newData['row1'] = row1;
		newData['row2'] = row2;

		this.model.addToStack(newData);
	},
	getNewStatus: function (changes) {
		var isChangedToOriginalData = this.model.isDataMatchOriginal(changes);

		if (isChangedToOriginalData) {
			return this.model.getOriginalStatus();
		} else if (this.model.statusNew()) {
			return this.model.get('status');
		} else {
			return STATUSES.UPDATED;
		}
	}
});


// WEBPACK FOOTER //
// ./app/views/subtitle-editor.js